module.exports = __webpack_public_path__ + "img/collapse.d60eb889.svg";